import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var Chart;
declare var $;

@Component({
  selector: 'app-chart-bar',
  templateUrl: './chart-bar.component.html',
  styleUrls: ['./chart-bar.component.scss']
})
export class ChartBarComponent implements OnInit {

  @Input() public element: string;
  @Input() public heightSize: string;
  @Input() public widthSize: string;
  @Input() public dataArray:any;
  @Input() public labelArray:any;
  @Input() public min: any = 0;
  @Input() public max: any = 10;
  @Input() public steps: any = 10;
  @Input() public printing: boolean = false;
  @Output() public chartReady: EventEmitter<void> = new EventEmitter<void>();

  public myChart;
  constructor() {
  }
  ngOnInit() {
    setTimeout(() => {
      this.startChart();
    }, 500);
  }

  startChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }
    this.myChart = new Chart(this.ctx(), {
        type: 'bar',
        data: this.data(),
        options: this.options()
    });
    this.chartReady.emit();
  }

  resizeChart() {
    if (this.myChart) {
      this.myChart.resize();
    }
  }

  data() {
    var gradientStroke = this.ctx().createLinearGradient(0, 500, 0, 320);
    gradientStroke.addColorStop(0, "#fa5c7c");
    gradientStroke.addColorStop(1, "#727cf5");
    return {
    labels: this.labelArray,
    //labels: ["Q1-12", "Q2-12", "Q3-13", "Q4-12","Q1-12", "Q2-12", "Q3-13", "Q4-12","Q1-12", "Q2-12", "Q3-13", "Q4-12","Q1-12", "Q2-12", "Q3-13", "Q4-12"],
    datasets: [
        {   backgroundColor: gradientStroke,
            borderColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            hoverBorderColor: gradientStroke,
            //data: [65, 59, 80, 81, 56, 55, 40, 50, 80, 30, 80, 83, 84, 87, 54, 75]
            data: this.dataArray
        }
    ]};
  }

  options() {
    return {
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            yAxes: [{
                gridLines: {
                    display: true
                },
                stacked: false,
                ticks: {
                    stepSize: this.getStepSize(),
                    beginAtZero:true
                }
            }],
            xAxes: [{
                ticks: {
                    fontSize: 9
                },
                barPercentage: 1,
                categoryPercentage: 0.8,
                stacked: false,
                gridLines: {
                    color: "rgba(0,0,0,0.01)"
                }
            }]
        }
    };
  }

  getStepSize() {
    console.log("###El minimo es = ",this.min);
    if (this.max == this.min) {
      return this.steps;
    }
    return (this.max - this.min) / this.steps;
  }

  ctx() {
    return this.input().get(0).getContext('2d');
  }

  input() {
      return $('#' + this.element);
  }

  setChartDraw() {
    var draw = Chart.controllers.line.prototype.draw;
      Chart.controllers.line.prototype.draw = function () {
          draw.apply(this, arguments);
          var ctx = this.chart.chart.ctx;
          var _stroke = ctx.stroke;
          ctx.stroke = function () {
              ctx.save();
              ctx.shadowColor = 'rgba(0,0,0,0.01)';
              ctx.shadowBlur = 20;
              ctx.shadowOffsetX = 0;
              ctx.shadowOffsetY = 5;
              _stroke.apply(this, arguments);
              ctx.restore();
          }
      };
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => {
      if (changes.printing && !changes.printing.firstChange) {
        console.log('resazing');
        this.resizeChart();
      } else {
        this.startChart();
      }
    }, 500);
  }


}



// WEBPACK FOOTER //
// ./src/app/components/tools/charts/chart-bar/chart-bar.component.ts